import { render, staticRenderFns } from "./ShortcutOverview.vue?vue&type=template&id=575429a6&scoped=true"
import script from "./ShortcutOverview.vue?vue&type=script&lang=js"
export * from "./ShortcutOverview.vue?vue&type=script&lang=js"
import style0 from "./ShortcutOverview.vue?vue&type=style&index=0&id=575429a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575429a6",
  null
  
)

export default component.exports